(function () {
  var root = document.documentElement;
  var loader = document.querySelector('[data-tsuki-loader]');

  if (!loader) {
    root.classList.remove('tsuki-loader-pending');
    return;
  }

  if (!root.classList.contains('tsuki-loader-pending')) {
    loader.remove();
    return;
  }

  var car = loader.querySelector('[data-tsuki-loader-car]');
  var wheel = loader.querySelector('[data-tsuki-loader-wheel]');
  var logo = loader.querySelector('[data-tsuki-loader-logo]');
  var runner = loader.querySelector('.tsuki-site-loader__runner');
  var smokeLayer = loader.querySelector('[data-tsuki-loader-smoke]');
  var progressBar = loader.querySelector('[data-tsuki-loader-progress]');
  var percent = loader.querySelector('[data-tsuki-loader-percent]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finished = false;
  var started = false;
  var startedAt = 0;
  var lastSmokeAt = -100;
  var frameId;
  var finishTimer;
  var safetyTimer;
  var startupTimer;

  function cssTimeToMilliseconds(value) {
    var parsed = parseFloat(value);
    if (!Number.isFinite(parsed)) return 2800;
    return value.indexOf('ms') > -1 ? parsed : parsed * 1000;
  }

  var duration = reduceMotion
    ? 1100
    : cssTimeToMilliseconds(
        window.getComputedStyle(loader).getPropertyValue('--tsuki-loader-duration').trim()
      );

  function rememberPlayback() {
    try {
      window.sessionStorage.setItem('tsuki-loader-played-v3', '1');
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; the loader still completes normally.
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape') finish();
  }

  function setProgress(value) {
    var safeValue = Math.max(0, Math.min(100, value));
    if (progressBar) progressBar.style.width = safeValue.toFixed(2) + '%';
    if (percent) percent.textContent = Math.round(safeValue) + '%';
  }

  function emitSmoke() {
    if (!runner || !smokeLayer || reduceMotion) return;

    var rect = runner.getBoundingClientRect();
    if (rect.right < -10 || rect.left > window.innerWidth + 10) return;

    var puff = document.createElement('i');
    var size = Math.max(12, Math.min(24, rect.width * (0.09 + Math.random() * 0.035)));
    var wheelX = rect.left + rect.width * 0.165;
    var wheelY = rect.top + rect.height * 0.67;

    puff.style.left = wheelX - size * 0.55 + 'px';
    puff.style.top = wheelY - size * 0.45 + 'px';
    puff.style.setProperty('--smoke-size', size + 'px');
    puff.style.setProperty('--smoke-life', 690 + Math.round(Math.random() * 250) + 'ms');
    puff.style.setProperty('--smoke-drift', -18 - Math.round(Math.random() * 30) + 'px');
    puff.style.setProperty('--smoke-rise', -20 - Math.round(Math.random() * 34) + 'px');
    puff.style.setProperty('--smoke-scale', (1.85 + Math.random() * 0.65).toFixed(2));
    smokeLayer.appendChild(puff);
    puff.addEventListener('animationend', function () { puff.remove(); }, { once: true });
  }

  function update(now) {
    if (finished) return;
    if (!startedAt) startedAt = now;

    var elapsed = now - startedAt;
    var ratio = Math.min(1, elapsed / duration);
    setProgress(ratio * 100);

    if (!reduceMotion && elapsed - lastSmokeAt >= 44 && ratio < 0.985) {
      lastSmokeAt = elapsed;
      emitSmoke();
    }

    if (ratio < 1) {
      frameId = window.requestAnimationFrame(update);
      return;
    }

    setProgress(100);
    finishTimer = window.setTimeout(finish, 110);
  }

  function finish() {
    if (finished) return;
    finished = true;
    window.cancelAnimationFrame(frameId);
    window.clearTimeout(finishTimer);
    window.clearTimeout(safetyTimer);
    window.clearTimeout(startupTimer);
    document.removeEventListener('keydown', onKeydown);
    rememberPlayback();
    setProgress(100);
    loader.classList.add('is-leaving');

    window.setTimeout(function () {
      root.classList.remove('tsuki-loader-pending');
      loader.remove();
    }, 380);
  }

  function start() {
    if (finished || started) return;
    started = true;
    window.clearTimeout(startupTimer);
    loader.classList.add('is-ready');

    // Give the browser two paint frames to display every loader asset before
    // the percentage, car, and smoke animation begin.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (finished) return;
        loader.classList.add('is-running');
        frameId = window.requestAnimationFrame(update);
      });
    });
  }

  function waitForImage(image) {
    if (!image) return Promise.resolve();

    return new Promise(function (resolve, reject) {
      function decodeAndResolve() {
        if (!image.naturalWidth) {
          reject(new Error('Loader image could not be displayed'));
          return;
        }

        if (typeof image.decode === 'function') {
          image.decode().then(resolve).catch(function () {
            // A completed image can still be painted if decode() is unsupported
            // or rejects because the browser has already decoded it.
            if (image.complete && image.naturalWidth) resolve();
            else reject(new Error('Loader image could not be decoded'));
          });
          return;
        }

        resolve();
      }

      if (image.complete) {
        decodeAndResolve();
        return;
      }

      image.addEventListener('load', decodeAndResolve, { once: true });
      image.addEventListener('error', function () {
        reject(new Error('Loader image failed to load'));
      }, { once: true });
    });
  }

  var ready = Promise.all([
    waitForImage(car),
    waitForImage(wheel),
    waitForImage(logo)
  ]);

  setProgress(0);
  ready.then(start).catch(finish);

  // Never leave a visitor behind the loader if a connection or asset stalls.
  startupTimer = window.setTimeout(finish, 5000);

  loader.addEventListener('click', finish, { once: true });
  document.addEventListener('keydown', onKeydown);
  safetyTimer = window.setTimeout(finish, 8500);
})();
